import type { AxiosError } from 'axios';

import { DownloadFileError } from '../../util/downloadFileError';
import { campaignGraphqlManager } from '../campaignGraphqlManager';
import { DEFAULT_CUSTOM_PACING_API_ROUTE } from './constants';

const DOWNLOAD_CUSTOM_PACING_REPORT_ENDPOINT = `${DEFAULT_CUSTOM_PACING_API_ROUTE}/download-csv-report`;

const DEFAULT_DOWNLOAD_CUSTOM_PACING_REPORT_ERROR_NAME = 'Cannot download custom pacing report!';
const DEFAULT_DOWNLOAD_CUSTOM_PACING_REPORT_ERROR_MESSAGE = 'Unknown issue occurred!';

type DownloadCustomPacingReportErrorResponse = {
  message?: string;
};

const makeErrorInfoFromResponse = (error: AxiosError<DownloadCustomPacingReportErrorResponse>): DownloadFileError => {
  if (!error?.response?.data?.message) {
    return new DownloadFileError(
      DEFAULT_DOWNLOAD_CUSTOM_PACING_REPORT_ERROR_MESSAGE,
      DEFAULT_DOWNLOAD_CUSTOM_PACING_REPORT_ERROR_NAME
    );
  }

  return new DownloadFileError(error.response.data.message, DEFAULT_DOWNLOAD_CUSTOM_PACING_REPORT_ERROR_NAME);
};

export const getDownloadCustomPacingReportRequest = async (reportId: string): Promise<Blob> => {
  return campaignGraphqlManager
    .get(DOWNLOAD_CUSTOM_PACING_REPORT_ENDPOINT, {
      responseType: 'blob',
      params: { reportId },
    })
    .then((response) => response.data)
    .catch((error: AxiosError<DownloadCustomPacingReportErrorResponse>) =>
      Promise.reject(makeErrorInfoFromResponse(error))
    );
};
